import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { setLocaleStorage } from "../lib/format";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: cfg } = await api.get("/config");
        setConfig(cfg);
        try {
          const { data: me } = await api.get("/auth/me");
          if (me?.settings?.locale) setLocaleStorage(me.settings.locale);
          setUser(me);
        } catch {
          setUser(false);
        }
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("tj_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("tj_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ config, user, setUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
